/* global axios */
import ApiClient from './ApiClient';

class KanbanFoldersAPI extends ApiClient {
  constructor() {
    super('kanban_folders', { accountScoped: true });
  }

  getFolders() {
    return axios.get(this.url);
  }

  createFolder(data) {
    return axios.post(this.url, { kanban_folder: data });
  }

  updateFolder(id, data) {
    return axios.patch(`${this.url}/${id}`, { kanban_folder: data });
  }

  deleteFolder(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  reorder(ids) {
    return axios.patch(`${this.url}/reorder`, { ids });
  }
}

export default new KanbanFoldersAPI();
